import React from "react";
import PropTypes from "prop-types";
import LabelledRadioOption from "common/LabelledRadioOption";
import { StaffAppointmentPreferences } from 'utils/types';
import RadioOptionForHourlyDropdown from './RadioOptionForHourlyDropdown';
import css from "./OfficeHourSchedulingOptions.scss";
import { getWord } from "utils/tenant";
import { assign } from 'lodash';
import { isEmptyString } from 'utils/text';
import HoursBefore from "./HoursBefore";

// Scheduling Deadline for staff users' office hours.
// It's the deadline by which students need to schedule appointments prior to the scheduled office hour.
const OfficeHourSchedulingOptions = ({appointmentPreferences, setValue}) => {
    return(
        <div className={css['radio-group']} data-role="controlgroup" aria-labelledby="schedulingDeadline">
            <div className={css['no-deadline']}>
                  <LabelledRadioOption isChecked={appointmentPreferences.deadLineType === 'NONE' || isEmptyString(appointmentPreferences.deadLineType)}
                                       label="No Deadline"
                                       labelId="noDeadline"
                                       onRadioSelect ={() => setValue({deadLineType: 'NONE'})}
                                       radioGroupName="schedulingOptions" />
            </div>
            <RadioOptionForHourlyDropdown dropdownValue={appointmentPreferences.deadLineValue.DAY_BEFORE}
                                          isChecked={appointmentPreferences.deadLineType === 'DAY_BEFORE'}
                                          onRadioSelect={() => setValue({ deadLineType: 'DAY_BEFORE'})}
                                          radioGroupName="schedulingOptions"
                                          labelId="dayBefore"
                                          ariaLabel={`Set schedule deadline to the day before the ${getWord('officeHours', true)} at`} // this is redundant but needed for the select
                                          radioLabel={<>The day <span className={css['emphasized-underline-text']}>before</span>
                                                     {` the ${getWord('officeHours', true)} at:`}</>}
                                          onChange={(time) =>
                                              setValue({ deadLineValue: assign({}, appointmentPreferences.deadLineValue, { DAY_BEFORE: time }) })} />


            <RadioOptionForHourlyDropdown dropdownValue={appointmentPreferences.deadLineValue.ON_DAY}
                                          isChecked={appointmentPreferences.deadLineType === 'ON_DAY'}
                                          onRadioSelect={() => setValue({ deadLineType: 'ON_DAY'})}
                                          labelId="dayOf"
                                          radioGroupName="schedulingOptions"
                                          ariaLabel={`Set schedule deadline to the day of the ${getWord('officeHours', true)} at`} // this is redundant but needed for the select
                                          radioLabel={<>The day <span className={css['emphasized-underline-text']}>of</span>
                                                        {` the ${getWord('officeHours', true)} at:`}</>}
                                          onChange={(time) =>
                                              setValue({ deadLineValue: assign({}, appointmentPreferences.deadLineValue, { ON_DAY: time }) })} />

            <HoursBefore isSelected={appointmentPreferences.deadLineType === 'HOURS_BEFORE'}
                         hoursValue={appointmentPreferences.deadLineValue.HOURS_BEFORE}
                         onHoursInput={(minutes) => setValue({ deadLineValue: assign({}, appointmentPreferences.deadLineValue, { HOURS_BEFORE: minutes }) })}
                         onRadioSelect={() => setValue({ deadLineType: 'HOURS_BEFORE' })} />

        </div>
    );
};

OfficeHourSchedulingOptions.propTypes = {
    appointmentPreferences: StaffAppointmentPreferences.isRequired,
    setValue: PropTypes.func
};

export default OfficeHourSchedulingOptions;
